function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18ea95;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.43 10.103)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.227 10.9)"
}, React.createElement("path", {
  className: "a",
  d: "M-1585.321,998.4h-.328v-9.089l-4.627-4.627h-11.05l-8.445-8.445.232-.232,8.349,8.349h11.05l4.819,4.819Z",
  transform: "translate(1609.771 -976.009)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(27.6 32.379)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(21.191 0.913)"
}, React.createElement("path", {
  className: "a",
  d: "M-1499.762,924.482h-6.52v-.328h6.384l5.539-5.539v-3.53h.328v3.666Z",
  transform: "translate(1506.282 -915.085)"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(35.827 4.129)"
}, React.createElement("path", {
  className: "a",
  d: "M-1416.67,951.985H-1417v-9.907l2.153-2.153v-5.22h.328v5.355l-2.153,2.153Z",
  transform: "translate(1416.998 -934.705)"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(35.831 10.9)"
}, React.createElement("path", {
  className: "a",
  d: "M-1416.642,1004.779h-.328V993.6l3.766-3.766v-7.377l6.444-6.444.232.232-6.348,6.348v7.377l-3.766,3.766Z",
  transform: "translate(1416.97 -976.009)"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(39.043 22.663)"
}, React.createElement("path", {
  className: "a",
  d: "M-1397.05,1067.937h-.328v-12.36l3.557-3.557h4.973v-4.251h.328v4.579h-5.166l-3.365,3.365Z",
  transform: "translate(1397.377 -1047.769)"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(24.734 27.514)"
}, React.createElement("rect", {
  className: "a",
  width: 0.328,
  height: 17.961
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(5.14 24.291)"
}, React.createElement("rect", {
  className: "a",
  width: 0.328,
  height: 16.561,
  transform: "translate(0 0.232) rotate(-45)"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.749 20.537)"
}, React.createElement("path", {
  className: "a",
  d: "M-1618.184,1054.649l-12.8-12.8V1034.8h.328v6.909l12.708,12.708Z",
  transform: "translate(1630.988 -1034.8)"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(20.278 9.19)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(37.231 3.216)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(32.366)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(35.078 20.496)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref17 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(45.244 10.103)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(46.845 21.729)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(38.294 41.919)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(35.082 38.757)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(23.985 26.601)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref22 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(23.985 44.563)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref23 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(16.053 34.914)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref24 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.343 23.494)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref25 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 19.624)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12.756 39.357)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0 1.826) rotate(-90)"
}));

var SvgBusinessIntelligenceSolutions = function SvgBusinessIntelligenceSolutions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48.671,
    height: 46.388,
    viewBox: "0 0 48.671 46.388",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBusinessIntelligenceSolutions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Business_Intelligence_Solutions.5c9879b0.svg";
export { ForwardRef as ReactComponent };